<template>
  <div id="loader">
    <!-- class="object-page-wrapper" -->
    <div class="floor-plan-container">
      <div class="page-content d-flex f-column">
        <div class="page-content__meta d-flex f-between">
          <h1 class="page-title">План этажа</h1>
          <!-- <div @click="closeFloorPlan()" class="go-back-icon">
            <svg class="d-block ml-auto" xmlns="http://www.w3.org/2000/svg" width="17.999" height="18"
              viewBox="0 0 17.999 18">
              <path id="Union_9" data-name="Union 9"
                d="M-10501-7368.2l-7.2,7.2-1.8-1.8,7.2-7.2-7.2-7.2,1.8-1.8,7.2,7.2,7.2-7.2,1.8,1.8-7.2,7.2,7.2,7.2-1.8,1.8Z"
                transform="translate(10510 7379)" fill="#fefefc" />
            </svg>
          </div> -->
        </div>
        <!-- show is max-width: 768px -->
        <div class="floor-plan__meta d-flex align-center">
          <div class="mobile-floor-plan-select">
            <span class="d-block text-white mb-2">ЭТАЖ</span>
            <select v-model="floor" @change="nextFloor(floor)">
              <option
                :value="item.id"
                v-for="(item, index) in floorLayouts"
                @click="floorToTheRout(item)"
                :key="index"
              >
                {{
                  item.floor_number < 10
                    ? "0" + item.floor_number
                    : item.floor_number
                }}
              </option>
            </select>
          </div>
          <!-- <div class="floor-plan__zoom ml-auto pointer p-relative" ref="zoom">
                <p>Увеличить планировку</p>
              </div> -->
        </div>

        <div class="f-full d-flex f-column p-relative">
          <div class="d-flex">
            <div class="flool-plan-left d-flex f-column">
              <span>ЭТАЖ</span>
              <div class="floor-counter p-relative">
                <div class="floor-shadow top-shadow"></div>
                <div class="counter-box" ref="scrollParent">
                  <div class="counter-inner">
                    <div
                      class="floor-counter__items"
                      v-for="(item, index) in floorLayouts"
                      :key="index"
                      :class="{
                        active: selectted_floor_number == item.floor_number,
                      }"
                      @click="nextFloor(item.id)"
                    >
                      {{
                        item.floor_number < 10
                          ? "0" + item.floor_number
                          : item.floor_number
                      }}
                    </div>
                  </div>
                </div>
                <div class="floor-shadow bottom-shadow"></div>
              </div>
            </div>

            <!-- plan image -->
            <div class="h-100 w-100 p-relative">
              <FloorPlanning ref="floorLayoutPlanning" />
            </div>
            <!-- <div class="flool-plan-middle">
              </div> -->

            <!-- <div class="flool-plan-right d-flex f-column text-right">
                <span>КОРПУС</span>
                <div class="floor-corps d-flex f-column f-full">
                  <div class="floor-corps__items">A</div>
                  <div class="floor-corps__items active">B</div>
                  <div class="floor-corps__items">C</div>
                </div>
              </div> -->
          </div>
        </div>

        <!-- <div class="floor-plan__control d-flex f-wrap">
            <div class="floor-plan__control-items items-free d-flex align-center">
              <div class="p-relative mr-3"></div>
              <span>Свободно</span>
            </div>
            <div class="floor-plan__control-items items-sell d-flex align-center">
              <div class="p-relative mr-3"></div>
              <span>Продано</span>
            </div>
            <div class="floor-plan__control-items items-booked d-flex align-center">
              <div class="p-relative mr-3"></div>
              <span>Забронировано</span>
            </div>
          </div> -->
      </div>
    </div>
    <BottomNavigation />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FloorPlanning from "./FloorPlanning.vue";
import BottomNavigation from "../Objects/components/BottomNavigation.vue";

export default {
  name: "floorPlanningCArousel",
  props: ["porche_id", "floor_number"],
  components: { FloorPlanning, BottomNavigation },

  data() {
    return {
      selectted_floor_number: null,
      floor: 1,
    };
  },
  computed: {
    ...mapGetters({
      floorLayouts: "floors/floorLayouts",
    }),
  },

  async created() {
    await this.fetchData();
  },

  methods: {
    ...mapActions({
      getFloorLayouts: "floors/getFloorLayouts",
    }),

    async fetchData() {
      if (this.porche_id) {
        await this.getFloorLayouts(this.porche_id)
          .then((res) => {
            if (this.floorLayouts) {
              let floorLayout = this.floorLayouts.find(
                (item) => item.floor_number == this.floor_number
              );
              if (floorLayout) {
                this.selectted_floor_number = floorLayout.floor_number;
                this.$refs["floorLayoutPlanning"].getFloorPlans(
                  floorLayout.layout_id,
                  floorLayout.floor_number
                );
              }
            }
          })
          .catch((err) => {
            this.loading = false;
          });
      }
    },

    nextFloor(id) {
      this.floor = id;
      let floorLayout = this.floorLayouts.find((item) => item.id == id);
      if (floorLayout) {
        this.selectted_floor_number = floorLayout.floor_number;
        this.$refs["floorLayoutPlanning"].getFloorPlans(
          floorLayout.layout_id,
          floorLayout.floor_number
        );

        this.$router.push({
          name: "floorPlanShow",
          params: {
            porche_id: this.$route.params.porche_id,
            floor_number: floorLayout.floor_number,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.plan__size #layout-canvas {
  // filter: brightness(130%);

  path {
    cursor: pointer;
    fill: #ca9760;
    opacity: 0;
    transition: 0.4s;

    &:hover {
      opacity: 1;
    }
  }

  svg text {
    pointer-events: none;
  }
}

.facad-level-number-title {
  width: 100%;
  padding: 0px 20px;
  font-size: 22px;
}

.text {
  color: lightgray;
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
  text-align: center;
}

.nomber__floor {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  overflow: auto;
  margin-bottom: 50px;
  height: calc(100vh - 60px);
  overflow-x: hidden;
  padding: 0 50px;
  padding-top: 134px;

  ul {
    margin: 0px;
    padding: 0px;
    list-style: none;

    li {
      position: relative;
      cursor: pointer;
    }

    li a {
      line-height: 34px;
      font-size: 20px;
      // font-family: var(--font-light);
      color: #0c3458;
      position: relative;
      cursor: pointer;
    }
  }
}

.nomber__floor::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  /* width of the entire scrollbar */
}

.nomber__floor::-webkit-scrollbar-track {
  background: #f1f5f8;
  /* color of the tracking area */
}

.nomber__floor::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  /* color of the scroll thumb */
  border-radius: 20px;
  /* roundness of the scroll thumb */
  border: 3px solid #f1f5f8;
  /* creates padding around scroll thumb */
}

.facad-level-number-image2 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.facad-level-number {
  width: 150px;
}

.facad-level-image.palanii {
  width: calc(100% - 150px);
}

.nomber__floor {
  opacity: 1;
}

.nomber__floor ul li {
  .floor-link__left,
  .floor-link__right {
    color: #fff;
  }
}

.load {
  position: relative;
  margin: 50px auto;
  width: 100px;
  height: 80px;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.loading_div {
  width: 100%;
  height: 100%;
  // height: calc(100vh - 60px);
  height: 100vh;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  overflow: hidden;
}

.loaded .loading_div {
  opacity: 0;
  transition: all 0.3s ease-out;
}

#loader {
  overflow: hidden;
  // height: calc(100vh - 60px);
}

.nomber__floor ul li:hover {
  .floor-link {
    background-color: #fff;
    border: 1px solid #e2e2e2;
  }

  .floor-link__left,
  .floor-link__right {
    color: #434649;
  }
}

.nomber__floor ul li.active {
  .floor-link {
    background-color: #0c3458;
    border: 1px solid #0c3458;
  }

  .floor-link__left,
  .floor-link__right {
    color: #fff;
  }

  .floor-link__num {
    color: #fff;
  }
}

.nomber__floor ul li {
  .floor-link {
    background-color: #ffffff;
    padding: 5px 7px;
    width: 130px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #fff;
  }

  .floor-link__left,
  .floor-link__right {
    color: #fff;
    font-size: 13px;
    font-weight: 300;
  }

  .floor-link__num {
    color: #434649;
    font-size: 15px;
    width: 30px;
    font-size: 14px;
    display: flex;
    justify-content: center;
  }
}
</style>

<style scoped>
.floor-plan-container {
  padding: 2rem 100px 0;
}
</style>
